var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.909 25.907H1.688a1.055 1.055 0 010-2.11h2.166V3.376A1.055 1.055 0 014.91 2.32H22.09c.582 0 1.054.473 1.054 1.055v20.423h2.168a1.055 1.055 0 110 2.109H4.909zm5.388-2.11H5.964V4.43h15.072v19.368h-4.334v-5.389c0-.582-.472-1.055-1.055-1.055h-4.295a1.055 1.055 0 00-1.055 1.055v5.389zm2.11 0h2.186v-4.333h-2.187v4.334z",
    fill: "#624DE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.205 7.67h2.148M15.648 7.67h2.147M9.205 11.966h2.148M15.648 11.966h2.147",
    stroke: "#624DE3",
    strokeOpacity: 0.5,
    strokeWidth: 2.109,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFirm;